import { render, staticRenderFns } from "./AppNavigationItem.vue?vue&type=template&id=b443633c&scoped=true"
import script from "./AppNavigationItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationItem.vue?vue&type=script&lang=js"
import style0 from "./AppNavigationItem.vue?vue&type=style&index=0&id=b443633c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b443633c",
  null
  
)

export default component.exports